import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router-dom';
import ArrowButton from '../../../../../components/arrow-button';
import {
  ChannelTypeInternal,
  MeterTypeInternal,
  VersionedFeatureType,
} from '../../../../../data-access/gql-types/graphql';
import { ROUTES } from '../../../../../routes/routes';
import { useDevicesAndChannelsContext } from '../../../context/devices-and-channels';
import { useCheckDeviceSupport } from '../../../hooks/version-map/use-check-device-support';
import AmpTransformers from '../components/amp-transformers';
import MeterPurpose from '../components/meter-purpose';
import { usePartialConfigChanged } from '../hooks/use-partial-config-changed';
import MeasurementsConfiguration from './measurements';

const MeterConfiguration: React.FC = () => {
  const { t } = useTranslation('configuration');
  const navigate = useNavigate();
  const { channelId } = useParams<{ channelType: ChannelTypeInternal; channelId: string }>();
  const ChannelId = channelId ?? '';
  const { channel, getDeviceById } = useDevicesAndChannelsContext();
  const { setTimeoutError } = usePartialConfigChanged({ channelId: ChannelId });
  const { checkSupport } = useCheckDeviceSupport();
  const device = getDeviceById(channel?.deviceId);

  const isStandalone =
    channel?.data?.type === ChannelTypeInternal.Meter && channel?.data?.meterType === MeterTypeInternal.Standalone;

  const tariffPersistenceSupported = checkSupport({
    feature: VersionedFeatureType.TariffPersistenceOnDevice,
    supportKey: device?.payload.model,
    currentVersion: channel?.currentFirmwareVersion,
  });

  if (!channel) return null;

  return (
    <>
      {isStandalone && (
        <>
          <AmpTransformers setTimeoutError={setTimeoutError} />
          <MeterPurpose setTimeoutError={setTimeoutError} />
        </>
      )}
      {tariffPersistenceSupported && (
        <>
          <hr />
          <ArrowButton
            title={t('tariffsConfiguration')}
            className="m-b-12"
            onClick={() => navigate(ROUTES.TariffConfiguration(ChannelId))}
            small
          />
        </>
      )}
      <MeasurementsConfiguration meterChannelId={ChannelId} />
    </>
  );
};

export default MeterConfiguration;
